import { CDS_ZINDEX } from '@revenuemarket/cds';
import { overlays } from '@revenuemarket/overlays';
import { Button, Modal, Tooltip } from 'antd';

import { InvoiceMapping } from '~apis/mapping';
import { CompanyUserPermission } from '~apis/role/type';
import WiringFlowModal from '~components/BankWiring/WiringFlowModal';
import { PermissionGuard } from '~components/Role/PermissionGuard';
import { useCompany } from '~hooks/queries/companies/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

interface Props {
  selectedItem: InvoiceMapping[];
  setSelectedItem: (selectedItem: InvoiceMapping[]) => void;
}
const SettlementWiringButton: React.FC<Props> = ({ selectedItem, setSelectedItem }) => {
  const { companyId } = useDemoAwareCompanyId();
  const { data: companyData } = useCompany({ companyId });
  const [modal, contextHolder] = Modal.useModal();
  const totalUnMappedAmount = Math.abs(
    selectedItem.reduce((acc, cur) => acc + cur.unmappedAmount, 0),
  );
  const totalLength = selectedItem.filter((item) => item.unmappedAmount !== 0).length;
  const disabled = totalUnMappedAmount === 0;
  const defaultDepositAccounts = selectedItem.map((item) => {
    return {
      amount: Math.abs(Number(item.unmappedAmount)),
      organizationCode: null,
      accountNumber: '',
      businessRegNo: item.counterPartyBusinessRegNumber,
      businessEntityId: item.businessEntityId,
      taxInvoiceId: item.taxInvoiceId,
      senderDescription: item.counterPartyCompanyName?.slice(0, 15),
      receiverDescription: companyData?.Data?.data?.name?.slice(0, 7),
    };
  });

  const onWireClick = () => {
    overlays.open(({ isOpen, onClose }) => (
      <WiringFlowModal
        open={isOpen}
        onCancel={onClose}
        defaultDepositAccounts={defaultDepositAccounts}
      />
    ));
  };

  const onWiringButtonClick = () => {
    if (disabled) return;

    modal.confirm({
      icon: null,
      zIndex: CDS_ZINDEX.FLOATING_BUTTON + 1,
      title: `세금계산서 ${totalLength}건 ${totalUnMappedAmount.toLocaleString()}원의 이체를 진행할까요?`,
      content: '매입 잔액이 없는 세금계산서는 제외됐습니다.',
      cancelText: '닫기',
      okButtonProps: {
        type: 'primary',
      },
      onOk: onWireClick,
      okText: '다음',
    });
  };

  return (
    <PermissionGuard required={CompanyUserPermission.CAN_MANAGE_WIRING}>
      <Tooltip
        zIndex={CDS_ZINDEX.POP_UP + 1}
        title={disabled ? '이체가 필요한 미정산 잔액이 없습니다.' : ''}
      >
        {contextHolder}
        <Button
          style={{
            color: disabled ? '#d9d9d9' : '',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          type="link"
          onClick={onWiringButtonClick}
        >
          선택항목 이체
        </Button>
      </Tooltip>
    </PermissionGuard>
  );
};

export default SettlementWiringButton;
